// The slice variable is the part of the state that you want to get loading from
//  ex. getStatusFromState('currentUser')(state)

export default function getStatusFromState(slice) {
  return state => state.getIn([slice, 'status'], '');
}
